export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AudioLanguages: { input: { main: LanguageIsoCode; languages: LanguageIsoCode[] }; output: { main: LanguageIsoCode; languages: LanguageIsoCode[] }; }
  BigInt: { input: string; output: string; }
  CatchPhrases: { input: import("./scalars").CatchPhraseMap; output: import("./scalars").CatchPhraseMap; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  Details: { input: import("./scalars").DetailsObject; output: import("./scalars").DetailsObject; }
  EmailAddress: { input: string; output: string; }
  ExcludedCountries: { input: import("./scalars").ExcludedCountries; output: import("./scalars").ExcludedCountries; }
  GenreTitles: { input: import("./scalars").GenreTitles; output: import("./scalars").GenreTitles; }
  JSON: { input: any; output: any; }
  Keywords: { input: import("./scalars").Keywords; output: import("./scalars").Keywords; }
  NonNegativeInt: { input: number; output: number; }
  PayoutTemplate: { input: any; output: any; }
  Synopsis: { input: import("./scalars").Synopsis; output: import("./scalars").Synopsis; }
  Titles: { input: import("./scalars").TitleMap; output: import("./scalars").TitleMap; }
  UUID: { input: string; output: string; }
};

export type AccountBuyerObjectType = {
  __typename?: 'AccountBuyerObjectType';
  audioOutputFormat?: Maybe<NestAudioOutputFormat>;
  billingEmail: Scalars['String']['output'];
  broadcastCountries: BroadcastCountriesType;
  broadcastLanguage: LanguageIsoCode;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: NestVideoOutputBitrate;
  videoOutputFormat: NestVideoOutputFormat;
};

export type AccountSellerObjectType = {
  __typename?: 'AccountSellerObjectType';
  billingEmail: Scalars['String']['output'];
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  metrics: SellerMetrics;
  postalAddress: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatId: Scalars['String']['output'];
};

export type AddToCartInput = {
  excludeEpisodeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  language: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type AssetBuilder = {
  __typename?: 'AssetBuilder';
  audioLanguage: Scalars['String']['output'];
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  buyer: Buyer;
  contents: Array<Contents>;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  license: License;
  program: Program;
  status: Scalars['String']['output'];
  subtitleLanguage: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export enum AssetBuilderStatus {
  Creating = 'CREATING',
  Error = 'ERROR',
  Finished = 'FINISHED',
  Pending = 'PENDING'
}

export type AssetBuilderV2 = {
  __typename?: 'AssetBuilderV2';
  audioLanguage: LanguageIsoCode;
  audioOutputFormat: AudioOutputFormatOutput;
  buyer: BuyerV2;
  createdAt: Scalars['DateTime']['output'];
  identifier: IdentifierV2;
  license: LicenseV2;
  program: ProgramV2;
  status: AssetBuilderStatus;
  subtitleLanguage: LanguageIsoCode;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoOutputBitrate: VideoOutputBitrateOutput;
  videoOutputFormat: VideoOutputFormatOutput;
};

export enum AudioOutputFormatOutput {
  Aac = 'AAC',
  Ac3 = 'AC3',
  Aiff = 'AIFF',
  Eac3 = 'EAC3',
  Wav = 'WAV'
}

export type BackofficeBuyerObjectType = {
  __typename?: 'BackofficeBuyerObjectType';
  audioOutputFormat?: Maybe<NestAudioOutputFormat>;
  billingEmail: Scalars['String']['output'];
  broadcastCountries: BroadcastCountriesType;
  broadcastLanguage: LanguageIsoCode;
  broadcastType: NestBroadcastType;
  businessProvider?: Maybe<BuyerBusinessProvider>;
  businessProviderId?: Maybe<Scalars['String']['output']>;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hourCost: Scalars['Float']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesDuration: Scalars['Int']['output'];
  payinIban?: Maybe<Scalars['String']['output']>;
  payoutTemplate: Scalars['JSON']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  replayRights: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: NestVideoOutputBitrate;
  videoOutputFormat: NestVideoOutputFormat;
};

export type BackofficeSellerObjectType = {
  __typename?: 'BackofficeSellerObjectType';
  billingEmail: Scalars['String']['output'];
  businessProvider?: Maybe<SellerBusinessProvider>;
  cloudFrontUrl?: Maybe<Scalars['String']['output']>;
  commissionRate: Scalars['Float']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  payoutTemplate: Scalars['JSON']['output'];
  postalAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type BroadcastCountries = {
  __typename?: 'BroadcastCountries';
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BroadcastCountriesInput = {
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BroadcastCountriesType = {
  __typename?: 'BroadcastCountriesType';
  countries: Array<CountryIsoCode>;
  main: CountryIsoCode;
};

export type BusinessProvider = {
  __typename?: 'BusinessProvider';
  bankAccountDetails: BankAccountDetails;
  billingEmail: Scalars['EmailAddress']['output'];
  buyers: Array<Buyer>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesQuantity: Scalars['Int']['output'];
  postalAddress: Scalars['String']['output'];
  programsDuration: Scalars['Int']['output'];
  sellers: Array<Seller>;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
};

export type BusinessProviderFiltersInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  licensesQuantity?: InputMaybe<RangeInput>;
  metricsDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  metricsDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  programsDuration?: InputMaybe<RangeInput>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessProviderOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  licensesQuantity?: InputMaybe<SearchDirection>;
  programsDuration?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type Buyer = {
  __typename?: 'Buyer';
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  billingEmail: Scalars['EmailAddress']['output'];
  broadcastCountries: BroadcastCountries;
  broadcastLanguage: Scalars['String']['output'];
  broadcastType: Scalars['String']['output'];
  businessProvider?: Maybe<BusinessProvider>;
  contactEmail: Scalars['EmailAddress']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hourCost: Scalars['Float']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  licensesDuration: Scalars['Int']['output'];
  payinIban: Scalars['String']['output'];
  payoutTemplate: Scalars['PayoutTemplate']['output'];
  postalAddress: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
  replayRights: Scalars['Boolean']['output'];
  tenant: Tenant;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export type BuyerAccountMutations = {
  __typename?: 'BuyerAccountMutations';
  update: AccountBuyerObjectType;
};


export type BuyerAccountMutationsUpdateArgs = {
  input: UpdateBuyerAccountInput;
};

export enum BuyerAudioOutputFormat {
  Aac = 'AAC',
  Ac3 = 'AC3',
  Aiff = 'AIFF',
  Eac3 = 'EAC3',
  Wav = 'WAV'
}

export type BuyerBackofficeMutations = {
  __typename?: 'BuyerBackofficeMutations';
  create: BackofficeBuyerObjectType;
  update: BackofficeBuyerObjectType;
};


export type BuyerBackofficeMutationsCreateArgs = {
  input: CreateBuyerInput;
};


export type BuyerBackofficeMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateBuyerInput;
};

export type BuyerBusinessProvider = {
  __typename?: 'BuyerBusinessProvider';
  contactName?: Maybe<Scalars['String']['output']>;
  identifier: Identifier;
};

export type BuyerClaimFiltersInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerMutations = {
  __typename?: 'BuyerMutations';
  account: BuyerAccountMutations;
  backoffice: BuyerBackofficeMutations;
};

export type BuyerQueries = {
  __typename?: 'BuyerQueries';
  account?: Maybe<AccountBuyerObjectType>;
  backoffice?: Maybe<BackofficeBuyerObjectType>;
};

export type BuyerSearchFilterInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  mainBroadcastCountry?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerSearchOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  mainBroadcastCountry?: InputMaybe<SearchDirection>;
  publicName?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type BuyerSearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export type BuyerV2 = {
  __typename?: 'BuyerV2';
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  identifier: IdentifierV2;
  legalName: Scalars['String']['output'];
};

export enum BuyerVideoOutputBitrate {
  B_2_5 = 'B_2_5',
  B_5 = 'B_5',
  B_25 = 'B_25',
  B_30 = 'B_30',
  B_50 = 'B_50'
}

export enum BuyerVideoOutputFormat {
  Mov = 'MOV',
  Mp4 = 'MP4',
  Mxf = 'MXF'
}

export type BuyersQueries = {
  __typename?: 'BuyersQueries';
  backoffice: SearchBackofficeBuyersOutput;
};


export type BuyersQueriesBackofficeArgs = {
  filter?: InputMaybe<BuyerSearchFilterInput>;
  orderBy?: InputMaybe<BuyerSearchOrderByInput>;
  pagination?: InputMaybe<BuyerSearchPaginationInput>;
};

export type Cart = {
  __typename?: 'Cart';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  programs: Array<CartProgram>;
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CartBillingMutations = {
  __typename?: 'CartBillingMutations';
  addToCart: CurrentCart;
  removeFromCart: CurrentCart;
  updateCart: CurrentCart;
};


export type CartBillingMutationsAddToCartArgs = {
  input: AddToCartInput;
};


export type CartBillingMutationsRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};


export type CartBillingMutationsUpdateCartArgs = {
  input: UpdateCartInput;
};

export type CartMutations = {
  __typename?: 'CartMutations';
  billing: CartBillingMutations;
};

export type CartProgram = {
  __typename?: 'CartProgram';
  language: Scalars['String']['output'];
  program: Program;
};

export type CatalogFormat = {
  __typename?: 'CatalogFormat';
  category?: Maybe<Category>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editorialization?: Maybe<EditorializationObjectType>;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  masterPreviewUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<MasterTechnicalDetails>;
  otherProductionCountries: Array<OtherProductionCountryObjectType>;
  production?: Maybe<ProductionObjectType>;
  rightExclusivity: Scalars['Boolean']['output'];
  seller?: Maybe<PublicSeller>;
  timeslot: FormatTimeslot;
  trailerPreviewUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CatalogSearchDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  Random = 'RANDOM'
}

export type Category = {
  __typename?: 'Category';
  catchPhrase: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CategoryProgram = {
  __typename?: 'CategoryProgram';
  catchPhrase: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  createdAt: Scalars['DateTime']['output'];
  identifier: IdentifierV2;
  license?: Maybe<LicenseV2>;
  message: Scalars['String']['output'];
  status: ClaimStatusOutput;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClaimFiltersInput = {
  buyer?: InputMaybe<BuyerClaimFiltersInput>;
  licenseId?: InputMaybe<Scalars['UUID']['input']>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  program?: InputMaybe<ProgramClaimFiltersInput>;
  seller?: InputMaybe<SellerClaimFiltersInput>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClaimStatus>;
};

export enum ClaimOrderFieldsInput {
  BuyerContactEmail = 'BUYER_CONTACT_EMAIL',
  BuyerContactName = 'BUYER_CONTACT_NAME',
  BuyerId = 'BUYER_ID',
  BuyerLegalName = 'BUYER_LEGAL_NAME',
  BuyerPublicName = 'BUYER_PUBLIC_NAME',
  CreatedAt = 'CREATED_AT',
  LicenseId = 'LICENSE_ID',
  ProgramTitle = 'PROGRAM_TITLE',
  SellerLegalName = 'SELLER_LEGAL_NAME',
  Sku = 'SKU',
  Status = 'STATUS'
}

export type ClaimOrderInput = {
  direction: SearchDirection;
  field: ClaimOrderFieldsInput;
};

export enum ClaimStatus {
  Opened = 'OPENED',
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ClaimStatusInput {
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ClaimStatusOutput {
  Opened = 'OPENED',
  Reissued = 'REISSUED',
  Solved = 'SOLVED',
  Unjustified = 'UNJUSTIFIED',
  Unsolved = 'UNSOLVED'
}

export enum ContentType {
  Format = 'FORMAT',
  Program = 'PROGRAM'
}

export type Contents = {
  __typename?: 'Contents';
  duration: Scalars['Int']['output'];
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  subtitleUrl: Scalars['String']['output'];
  titles: Scalars['Titles']['output'];
  videoUrl: Scalars['String']['output'];
};

export enum CountryExclusionTypeObjectType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export enum CountryIsoCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Uk = 'UK',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateBuyerInput = {
  audioOutputFormat?: InputMaybe<NestAudioOutputFormat>;
  billingEmail: Scalars['String']['input'];
  broadcastCountries: BroadcastCountriesInput;
  broadcastLanguage: LanguageIsoCode;
  broadcastType: NestBroadcastType;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  hourCost: Scalars['Float']['input'];
  legalName: Scalars['String']['input'];
  licensesDuration: Scalars['Int']['input'];
  payoutTemplate: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  publicName: Scalars['String']['input'];
  replayRights: Scalars['Boolean']['input'];
  vatId: Scalars['String']['input'];
  videoOutputBitrate: NestVideoOutputBitrate;
  videoOutputFormat: NestVideoOutputFormat;
};

export type CreateClaimInput = {
  licenseId: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
};

export type CreateExcludedCountriesTemplateInput = {
  excludedCountries: Array<ExcludedCountryInputType>;
  templateName: Scalars['String']['input'];
};

/** Create multipart upload response */
export type CreateMultipartUploadResponse = {
  __typename?: 'CreateMultipartUploadResponse';
  key: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
};

export type CreateSellerInput = {
  billingEmail: Scalars['String']['input'];
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  commissionRate: Scalars['Float']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  payoutTemplate: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};

export type CurrentCart = {
  __typename?: 'CurrentCart';
  identifier: CurrentCartIdentifier;
  programs: Array<CurrentCartProgram>;
  total: Scalars['Float']['output'];
};

export type CurrentCartIdentifier = {
  __typename?: 'CurrentCartIdentifier';
  id: Scalars['UUID']['output'];
};

export type CurrentCartProgram = {
  __typename?: 'CurrentCartProgram';
  language: Scalars['String']['output'];
  program: CurrentCartProgramDetail;
};

export type CurrentCartProgramDetail = {
  __typename?: 'CurrentCartProgramDetail';
  audioLanguages: Scalars['JSON']['output'];
  coverUrl?: Maybe<Scalars['String']['output']>;
  creditRollUrl?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesQuantity: Scalars['Int']['output'];
  firstBroadcastDate?: Maybe<Scalars['DateTime']['output']>;
  identifier: CurrentCartIdentifier;
  masterSubtitles: Array<CurrentCartProgramSubtitle>;
  parent?: Maybe<CurrentCartProgramParent>;
  price: Scalars['Float']['output'];
  seller: CurrentCartProgramSeller;
  titles: Scalars['JSON']['output'];
};

export type CurrentCartProgramParent = {
  __typename?: 'CurrentCartProgramParent';
  identifier: CurrentCartIdentifier;
  titles: Scalars['JSON']['output'];
};

export type CurrentCartProgramSeller = {
  __typename?: 'CurrentCartProgramSeller';
  legalName: Scalars['String']['output'];
};

export type CurrentCartProgramSubtitle = {
  __typename?: 'CurrentCartProgramSubtitle';
  language: Scalars['String']['output'];
};

export type DashboardFormat = {
  __typename?: 'DashboardFormat';
  category: Category;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editorialization: EditorializationObjectType;
  excludedCountries: Array<FormatExcludedCountry>;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  lifecycle?: Maybe<LifecycleObjectType>;
  masterPreviewUrl?: Maybe<Scalars['String']['output']>;
  masterSubtitleUrl?: Maybe<Scalars['String']['output']>;
  masterTechnicalDetails?: Maybe<MasterTechnicalDetails>;
  otherProductionCountries: Array<OtherProductionCountryObjectType>;
  production?: Maybe<ProductionObjectType>;
  seller?: Maybe<SellerObjectType>;
  sellerId: Scalars['String']['output'];
  timeslot: FormatTimeslot;
  trailerPreviewUrl?: Maybe<Scalars['String']['output']>;
  trailerSubtitleUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeleteBusinessProviderResult = {
  __typename?: 'DeleteBusinessProviderResult';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFormatOutput = {
  __typename?: 'DeleteFormatOutput';
  id: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type EditorializationInput = {
  durationDescription?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditorializationObjectType = {
  __typename?: 'EditorializationObjectType';
  durationDescription?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  synopsis: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExcludedCountriesTemplateFiltersInput = {
  excludedCountries: Array<ExcludedCountryInputType>;
};

export type ExcludedCountriesTemplateObjectType = {
  __typename?: 'ExcludedCountriesTemplateObjectType';
  createdAt: Scalars['DateTime']['output'];
  excludedCountries: Array<ExcludedCountryObjectType>;
  identifier: IdentifierV2;
  templateName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ExcludedCountriesTemplateOrderFieldsInput {
  Name = 'NAME'
}

export type ExcludedCountriesTemplateOrderInput = {
  direction: SearchDirection;
  field: ExcludedCountriesTemplateOrderFieldsInput;
};

export type ExcludedCountry = {
  __typename?: 'ExcludedCountry';
  countryISOCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ExcludedCountryInput = {
  countryISOCode: CountryIsoCode;
  exclusionType: ExclusionType;
};

export type ExcludedCountryInputType = {
  countryISOCode: CountryIsoCode;
  exclusionType: CountryExclusionTypeObjectType;
};

export type ExcludedCountryObjectType = {
  __typename?: 'ExcludedCountryObjectType';
  countryISOCode: CountryIsoCode;
  exclusionType: CountryExclusionTypeObjectType;
};

export enum ExclusionType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export type FormatBackofficeMutations = {
  __typename?: 'FormatBackofficeMutations';
  delete: DeleteFormatOutput;
};


export type FormatBackofficeMutationsDeleteArgs = {
  id: Scalars['UUID']['input'];
};

export type FormatDashboardMutations = {
  __typename?: 'FormatDashboardMutations';
  update: FormatObjectType;
};


export type FormatDashboardMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateFormatInput;
};

export type FormatExcludedCountry = {
  __typename?: 'FormatExcludedCountry';
  countryISOCode: Scalars['String']['output'];
  exclusionType: Scalars['String']['output'];
};

export type FormatMutations = {
  __typename?: 'FormatMutations';
  backoffice: FormatBackofficeMutations;
  dashboard: FormatDashboardMutations;
};

export type FormatObjectType = {
  __typename?: 'FormatObjectType';
  category: Category;
  coverImageFile?: Maybe<SourceFile>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editorialization: EditorializationObjectType;
  excludedCountries: Array<FormatExcludedCountry>;
  frapaId?: Maybe<Scalars['String']['output']>;
  genres: Array<Genre>;
  identifier: Identifier;
  lifecycle?: Maybe<LifecycleObjectType>;
  masterFile?: Maybe<SourceFile>;
  production?: Maybe<ProductionObjectType>;
  seller?: Maybe<SellerObjectType>;
  sellerId: Scalars['String']['output'];
  timeslot: FormatTimeslot;
  trailerFile?: Maybe<SourceFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FormatQueries = {
  __typename?: 'FormatQueries';
  backoffice?: Maybe<FormatObjectType>;
  catalog: CatalogFormat;
  dashboard?: Maybe<DashboardFormat>;
};


export type FormatQueriesBackofficeArgs = {
  id: Scalars['UUID']['input'];
};


export type FormatQueriesCatalogArgs = {
  id: Scalars['UUID']['input'];
};


export type FormatQueriesDashboardArgs = {
  id: Scalars['UUID']['input'];
};

export enum FormatTimeslot {
  AccessPrime = 'ACCESS_PRIME',
  Daytime = 'DAYTIME',
  LateNight = 'LATE_NIGHT',
  PrimeTime = 'PRIME_TIME'
}

export type FormatsQueries = {
  __typename?: 'FormatsQueries';
  backoffice: SearchBackofficeFormatsOutput;
  catalog: SearchCatalogFormatsOutput;
  dashboard: SearchDashboardFormatsOutput;
};


export type FormatsQueriesBackofficeArgs = {
  filter?: InputMaybe<SearchBackofficeFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};


export type FormatsQueriesCatalogArgs = {
  filter?: InputMaybe<SearchCatalogFormatsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};


export type FormatsQueriesDashboardArgs = {
  filter?: InputMaybe<SearchDashboardFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
};

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type GenreProgram = {
  __typename?: 'GenreProgram';
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type Identifier = {
  __typename?: 'Identifier';
  id: Scalars['UUID']['output'];
  sku: Scalars['Int']['output'];
};

export type IdentifierV2 = {
  __typename?: 'IdentifierV2';
  id: Scalars['UUID']['output'];
  sku: Scalars['Int']['output'];
};

export enum LanguageIsoCode {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Af = 'AF',
  Ak = 'AK',
  Am = 'AM',
  An = 'AN',
  Ar = 'AR',
  As = 'AS',
  Av = 'AV',
  Ay = 'AY',
  Az = 'AZ',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  Bi = 'BI',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Ca = 'CA',
  Ce = 'CE',
  Ch = 'CH',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cy = 'CY',
  Da = 'DA',
  De = 'DE',
  Dv = 'DV',
  Dz = 'DZ',
  Ee = 'EE',
  El = 'EL',
  En = 'EN',
  Eo = 'EO',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fa = 'FA',
  Ff = 'FF',
  Fi = 'FI',
  Fj = 'FJ',
  Fo = 'FO',
  Fr = 'FR',
  Fy = 'FY',
  Ga = 'GA',
  Gd = 'GD',
  Gl = 'GL',
  Gn = 'GN',
  Gu = 'GU',
  Gv = 'GV',
  Ha = 'HA',
  He = 'HE',
  Hi = 'HI',
  Ho = 'HO',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Hy = 'HY',
  Hz = 'HZ',
  Ia = 'IA',
  Id = 'ID',
  Ie = 'IE',
  Ig = 'IG',
  Ii = 'II',
  Ik = 'IK',
  Io = 'IO',
  Is = 'IS',
  It = 'IT',
  Iu = 'IU',
  Ja = 'JA',
  Jv = 'JV',
  Ka = 'KA',
  Kg = 'KG',
  Ki = 'KI',
  Kj = 'KJ',
  Kk = 'KK',
  Kl = 'KL',
  Km = 'KM',
  Kn = 'KN',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Ku = 'KU',
  Kv = 'KV',
  Kw = 'KW',
  Ky = 'KY',
  La = 'LA',
  Lb = 'LB',
  Lg = 'LG',
  Li = 'LI',
  Ln = 'LN',
  Lo = 'LO',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mg = 'MG',
  Mh = 'MH',
  Mi = 'MI',
  Mk = 'MK',
  Ml = 'ML',
  Mn = 'MN',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  My = 'MY',
  Na = 'NA',
  Nb = 'NB',
  Nd = 'ND',
  Ne = 'NE',
  Ng = 'NG',
  Nl = 'NL',
  Nn = 'NN',
  No = 'NO',
  Nr = 'NR',
  Nv = 'NV',
  Ny = 'NY',
  Oc = 'OC',
  Oj = 'OJ',
  Om = 'OM',
  Or = 'OR',
  Os = 'OS',
  Pa = 'PA',
  Pi = 'PI',
  Pl = 'PL',
  Ps = 'PS',
  Pt = 'PT',
  Qu = 'QU',
  Rm = 'RM',
  Rn = 'RN',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sq = 'SQ',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sw = 'SW',
  Ta = 'TA',
  Te = 'TE',
  Tg = 'TG',
  Th = 'TH',
  Ti = 'TI',
  Tk = 'TK',
  Tl = 'TL',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Ts = 'TS',
  Tt = 'TT',
  Tw = 'TW',
  Ty = 'TY',
  Ug = 'UG',
  Uk = 'UK',
  Ur = 'UR',
  Uz = 'UZ',
  Ve = 'VE',
  Vi = 'VI',
  Vo = 'VO',
  Wa = 'WA',
  Wo = 'WO',
  Xh = 'XH',
  Yi = 'YI',
  Yo = 'YO',
  Za = 'ZA',
  Zh = 'ZH',
  Zu = 'ZU'
}

export type License = {
  __typename?: 'License';
  assetBuilder?: Maybe<AssetBuilder>;
  broadcastCountry: CountryIsoCode;
  buyer: Buyer;
  clearanceDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  endingDate?: Maybe<Scalars['DateTime']['output']>;
  identifier: Identifier;
  price: Scalars['Float']['output'];
  program: Program;
  seller: Seller;
  transaction: Transaction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LicenseBuyerOrderBy = {
  broadcastCountries?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
};

export enum LicenseIsoCode {
  Ad = 'ad',
  Ae = 'ae',
  Af = 'af',
  Ag = 'ag',
  Ai = 'ai',
  Al = 'al',
  Am = 'am',
  Ao = 'ao',
  Aq = 'aq',
  Ar = 'ar',
  As = 'as',
  At = 'at',
  Au = 'au',
  Aw = 'aw',
  Ax = 'ax',
  Az = 'az',
  Ba = 'ba',
  Bb = 'bb',
  Bd = 'bd',
  Be = 'be',
  Bf = 'bf',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bj = 'bj',
  Bl = 'bl',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Bq = 'bq',
  Br = 'br',
  Bs = 'bs',
  Bt = 'bt',
  Bv = 'bv',
  Bw = 'bw',
  By = 'by',
  Bz = 'bz',
  Ca = 'ca',
  Cc = 'cc',
  Cd = 'cd',
  Cf = 'cf',
  Cg = 'cg',
  Ch = 'ch',
  Ci = 'ci',
  Ck = 'ck',
  Cl = 'cl',
  Cm = 'cm',
  Cn = 'cn',
  Co = 'co',
  Cr = 'cr',
  Cu = 'cu',
  Cv = 'cv',
  Cw = 'cw',
  Cx = 'cx',
  Cy = 'cy',
  Cz = 'cz',
  De = 'de',
  Dj = 'dj',
  Dk = 'dk',
  Dm = 'dm',
  Do = 'do',
  Dz = 'dz',
  Ec = 'ec',
  Ee = 'ee',
  Eg = 'eg',
  Eh = 'eh',
  Er = 'er',
  Es = 'es',
  Et = 'et',
  Fi = 'fi',
  Fj = 'fj',
  Fk = 'fk',
  Fm = 'fm',
  Fo = 'fo',
  Fr = 'fr',
  Ga = 'ga',
  Gb = 'gb',
  Gd = 'gd',
  Ge = 'ge',
  Gf = 'gf',
  Gg = 'gg',
  Gh = 'gh',
  Gi = 'gi',
  Gl = 'gl',
  Gm = 'gm',
  Gn = 'gn',
  Gp = 'gp',
  Gq = 'gq',
  Gr = 'gr',
  Gs = 'gs',
  Gt = 'gt',
  Gu = 'gu',
  Gw = 'gw',
  Gy = 'gy',
  Hk = 'hk',
  Hm = 'hm',
  Hn = 'hn',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Id = 'id',
  Ie = 'ie',
  Il = 'il',
  Im = 'im',
  In = 'in',
  Io = 'io',
  Iq = 'iq',
  Ir = 'ir',
  Is = 'is',
  It = 'it',
  Je = 'je',
  Jm = 'jm',
  Jo = 'jo',
  Jp = 'jp',
  Ke = 'ke',
  Kg = 'kg',
  Kh = 'kh',
  Ki = 'ki',
  Km = 'km',
  Kn = 'kn',
  Kp = 'kp',
  Kr = 'kr',
  Kw = 'kw',
  Ky = 'ky',
  Kz = 'kz',
  La = 'la',
  Lb = 'lb',
  Lc = 'lc',
  Li = 'li',
  Lk = 'lk',
  Lr = 'lr',
  Ls = 'ls',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Ly = 'ly',
  Ma = 'ma',
  Mc = 'mc',
  Md = 'md',
  Me = 'me',
  Mf = 'mf',
  Mg = 'mg',
  Mh = 'mh',
  Mk = 'mk',
  Ml = 'ml',
  Mm = 'mm',
  Mn = 'mn',
  Mo = 'mo',
  Mp = 'mp',
  Mq = 'mq',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Mu = 'mu',
  Mv = 'mv',
  Mw = 'mw',
  Mx = 'mx',
  My = 'my',
  Mz = 'mz',
  Na = 'na',
  Nc = 'nc',
  Ne = 'ne',
  Nf = 'nf',
  Ng = 'ng',
  Ni = 'ni',
  Nl = 'nl',
  No = 'no',
  Np = 'np',
  Nr = 'nr',
  Nu = 'nu',
  Nz = 'nz',
  Om = 'om',
  Pa = 'pa',
  Pe = 'pe',
  Pf = 'pf',
  Pg = 'pg',
  Ph = 'ph',
  Pk = 'pk',
  Pl = 'pl',
  Pm = 'pm',
  Pn = 'pn',
  Pr = 'pr',
  Ps = 'ps',
  Pt = 'pt',
  Pw = 'pw',
  Py = 'py',
  Qa = 'qa',
  Re = 're',
  Ro = 'ro',
  Rs = 'rs',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sb = 'sb',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Sh = 'sh',
  Si = 'si',
  Sj = 'sj',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Sv = 'sv',
  Sx = 'sx',
  Sy = 'sy',
  Sz = 'sz',
  Tc = 'tc',
  Td = 'td',
  Tf = 'tf',
  Tg = 'tg',
  Th = 'th',
  Tj = 'tj',
  Tk = 'tk',
  Tl = 'tl',
  Tm = 'tm',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Tt = 'tt',
  Tv = 'tv',
  Tw = 'tw',
  Tz = 'tz',
  Ua = 'ua',
  Ug = 'ug',
  Uk = 'uk',
  Um = 'um',
  Us = 'us',
  Uy = 'uy',
  Uz = 'uz',
  Va = 'va',
  Vc = 'vc',
  Ve = 've',
  Vg = 'vg',
  Vi = 'vi',
  Vn = 'vn',
  Vu = 'vu',
  Wf = 'wf',
  Ws = 'ws',
  Xk = 'xk',
  Ye = 'ye',
  Yt = 'yt',
  Za = 'za',
  Zm = 'zm',
  Zw = 'zw'
}

export type LicenseOrderBy = {
  buyer?: InputMaybe<LicenseBuyerOrderBy>;
  createdAt?: InputMaybe<SortOrder>;
  endingDate?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  program?: InputMaybe<LicenseProgramOrderBy>;
  seller?: InputMaybe<LicenseSellerOrderBy>;
  sku?: InputMaybe<SortOrder>;
};

export type LicenseProgramOrderBy = {
  titles?: InputMaybe<SortOrder>;
};

export type LicenseSellerOrderBy = {
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
};

export type LicenseV2 = {
  __typename?: 'LicenseV2';
  assetBuilder: AssetBuilderV2;
  buyer: BuyerV2;
  identifier: IdentifierV2;
  program: ProgramV2;
  seller: SellerV2;
  transaction: TransactionV2;
};

export type LifecycleObjectType = {
  __typename?: 'LifecycleObjectType';
  published: Scalars['Boolean']['output'];
  rightExclusivity: Scalars['Boolean']['output'];
  validated: Scalars['Boolean']['output'];
};

/** List parts response */
export type ListPartsResponse = {
  __typename?: 'ListPartsResponse';
  parts: Array<UploadedPart>;
};

export type MasterTechnicalDetails = {
  __typename?: 'MasterTechnicalDetails';
  aspectRatio?: Maybe<Scalars['String']['output']>;
  audioBitrate?: Maybe<Scalars['String']['output']>;
  audioMode?: Maybe<Scalars['String']['output']>;
  audioSampleRate?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  videoBitrate?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortMultipartUpload: Scalars['Boolean']['output'];
  buyer: BuyerMutations;
  cart: CartMutations;
  completeMultipartUpload: Scalars['Boolean']['output'];
  createBusinessProvider: BusinessProvider;
  createClaim: Claim;
  createExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  createMultipartUpload: CreateMultipartUploadResponse;
  createTransaction: Transaction;
  deleteBusinessProvider: DeleteBusinessProviderResult;
  deleteExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  deleteProgram: Program;
  deleteSourceFile: Scalars['Boolean']['output'];
  executeCognitoPostSignup: Scalars['Boolean']['output'];
  format: FormatMutations;
  getSignedUrlsMultipartUpload: Array<Scalars['String']['output']>;
  listParts: ListPartsResponse;
  mediaConvertJobStateChange: Scalars['Boolean']['output'];
  mediaInfoAnalysisCompleted: Scalars['Boolean']['output'];
  processTenantStackCreated: Scalars['Boolean']['output'];
  seller: SellerMutations;
  transcribeJobStateChange: Scalars['Boolean']['output'];
  translateTextTranslationJobStateChange: Scalars['Boolean']['output'];
  updateBusinessProvider: BusinessProvider;
  updateClaimStatus: Claim;
  updateExcludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  updateProgram: Program;
  updateTransactionStatus: TransactionV2;
  walletWithdraw: Scalars['Boolean']['output'];
};


export type MutationAbortMultipartUploadArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationCompleteMultipartUploadArgs = {
  key: Scalars['String']['input'];
  parts: Array<UploadedPartInput>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationCreateBusinessProviderArgs = {
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
};


export type MutationCreateClaimArgs = {
  input: CreateClaimInput;
};


export type MutationCreateExcludedCountriesTemplateArgs = {
  input: CreateExcludedCountriesTemplateInput;
};


export type MutationCreateMultipartUploadArgs = {
  fileSize: Scalars['BigInt']['input'];
  originalFilename: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  sourceFileContentType: SourceFileContentType;
};


export type MutationCreateTransactionArgs = {
  audioOutputFormat?: InputMaybe<BuyerAudioOutputFormat>;
  cartId?: InputMaybe<Scalars['UUID']['input']>;
  videoOutputBitrate?: InputMaybe<BuyerVideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<BuyerVideoOutputFormat>;
};


export type MutationDeleteBusinessProviderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExcludedCountriesTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationDeleteProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSourceFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationExecuteCognitoPostSignupArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetSignedUrlsMultipartUploadArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  totalParts: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationListPartsArgs = {
  key: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationMediaConvertJobStateChangeArgs = {
  durationInMs?: InputMaybe<Scalars['Int']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  jobStatus: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationMediaInfoAnalysisCompletedArgs = {
  domain: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  sourceFileId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationProcessTenantStackCreatedArgs = {
  stackId: Scalars['String']['input'];
};


export type MutationTranscribeJobStateChangeArgs = {
  failureReason?: InputMaybe<Scalars['String']['input']>;
  jobName: Scalars['String']['input'];
  jobStatus: Scalars['String']['input'];
};


export type MutationTranslateTextTranslationJobStateChangeArgs = {
  jobId: Scalars['String']['input'];
  jobStatus: Scalars['String']['input'];
};


export type MutationUpdateBusinessProviderArgs = {
  bic?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateClaimStatusArgs = {
  id: Scalars['UUID']['input'];
  status: ClaimStatusInput;
};


export type MutationUpdateExcludedCountriesTemplateArgs = {
  input: UpdateExcludedCountriesTemplateInput;
};


export type MutationUpdateProgramArgs = {
  awards?: InputMaybe<Scalars['String']['input']>;
  casting?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  coverImageFileId?: InputMaybe<Scalars['UUID']['input']>;
  creditRollFileId?: InputMaybe<Scalars['UUID']['input']>;
  directors?: InputMaybe<Scalars['String']['input']>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedCountries?: InputMaybe<Array<ExcludedCountryInput>>;
  firstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  genreIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id: Scalars['UUID']['input'];
  imdb?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isSegmentable?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['Keywords']['input']>;
  masterFileId?: InputMaybe<Scalars['UUID']['input']>;
  masterSubtitles?: InputMaybe<Array<SubtitleInput>>;
  productionCountry?: InputMaybe<CountryIsoCode>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  synopsis?: InputMaybe<Scalars['Synopsis']['input']>;
  titles?: InputMaybe<Scalars['Titles']['input']>;
  trailerFileId?: InputMaybe<Scalars['UUID']['input']>;
  trailerSubtitles?: InputMaybe<Array<SubtitleInput>>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateTransactionStatusArgs = {
  id: Scalars['UUID']['input'];
  status: TransactionStatusInput;
};


export type MutationWalletWithdrawArgs = {
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum NestAudioOutputFormat {
  Aac = 'AAC',
  Ac3 = 'AC3',
  Aiff = 'AIFF',
  Eac3 = 'EAC3',
  Wav = 'WAV'
}

export enum NestBroadcastType {
  Classic = 'CLASSIC',
  Fast = 'FAST',
  LocalVod = 'LOCAL_VOD'
}

export enum NestVideoOutputBitrate {
  B_2_5 = 'B_2_5',
  B_5 = 'B_5',
  B_25 = 'B_25',
  B_30 = 'B_30',
  B_50 = 'B_50'
}

export enum NestVideoOutputFormat {
  Mov = 'MOV',
  Mp4 = 'MP4',
  Mxf = 'MXF'
}

export type OtherProductionCountryInput = {
  countryIsoCode: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type OtherProductionCountryObjectType = {
  __typename?: 'OtherProductionCountryObjectType';
  countryIsoCode: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type PaginatedBusinessProvidersResult = {
  __typename?: 'PaginatedBusinessProvidersResult';
  count: Scalars['Int']['output'];
  items: Array<BusinessProvider>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginatedLicensesResult = {
  __typename?: 'PaginatedLicensesResult';
  count: Scalars['Int']['output'];
  licenses: Array<License>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginatedProgramsResult = {
  __typename?: 'PaginatedProgramsResult';
  Programs: Array<Program>;
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type PaginatedSourceFilesResult = {
  __typename?: 'PaginatedSourceFilesResult';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  sourceFiles: Array<SourceFile>;
};

export type PaginatedTransactionsResult = {
  __typename?: 'PaginatedTransactionsResult';
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  transactions: Array<Transaction>;
};

export type ProductionObjectType = {
  __typename?: 'ProductionObjectType';
  firstBroadcastDate?: Maybe<Scalars['DateTime']['output']>;
  productionCountry?: Maybe<Scalars['String']['output']>;
};

export type Program = {
  __typename?: 'Program';
  audioLanguages: Scalars['AudioLanguages']['output'];
  awards?: Maybe<Scalars['String']['output']>;
  casting?: Maybe<Scalars['String']['output']>;
  category: CategoryProgram;
  countriesRight?: Maybe<Array<CountryIsoCode>>;
  coverImageFile?: Maybe<SourceFile>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditRollFile?: Maybe<SourceFile>;
  creditRollUrl?: Maybe<Scalars['String']['output']>;
  directors?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  emptyEpisodes?: Maybe<Scalars['Int']['output']>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  episodesQuantity?: Maybe<Scalars['Int']['output']>;
  excludedCountries?: Maybe<Array<ExcludedCountry>>;
  firstBroadcastDate?: Maybe<Scalars['DateTime']['output']>;
  genres: Array<GenreProgram>;
  identifier: Identifier;
  imdb?: Maybe<Scalars['String']['output']>;
  isExclusive: Scalars['Boolean']['output'];
  isSegmentable: Scalars['Boolean']['output'];
  keywords?: Maybe<Scalars['Keywords']['output']>;
  licensesQuantity?: Maybe<Scalars['Int']['output']>;
  masterFile?: Maybe<SourceFile>;
  masterSubtitles?: Maybe<Array<Subtitle>>;
  parent?: Maybe<Program>;
  price?: Maybe<Scalars['Float']['output']>;
  productionCountryIsoCode?: Maybe<Scalars['String']['output']>;
  publicSeller: PublicSeller;
  published: Scalars['Boolean']['output'];
  quality?: Maybe<Scalars['String']['output']>;
  seller: Seller;
  synopsis: Scalars['Synopsis']['output'];
  titles: Scalars['Titles']['output'];
  trailerFile?: Maybe<SourceFile>;
  trailerSubtitles?: Maybe<Array<Subtitle>>;
  updatedAt: Scalars['DateTime']['output'];
  validated: Scalars['Boolean']['output'];
};

export type ProgramClaimFiltersInput = {
  language?: InputMaybe<LanguageIsoCode>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramOrderBy = {
  casting?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  directors?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  episodeNumber?: InputMaybe<SortOrder>;
  episodesQuantity?: InputMaybe<SortOrder>;
  firstBroadcastDate?: InputMaybe<SortOrder>;
  keywords?: InputMaybe<SortOrder>;
  licensesQuantity?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productionCountry?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  quality?: InputMaybe<SortOrder>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  seller?: InputMaybe<ProgramSellerOrderBy>;
  sku?: InputMaybe<SortOrder>;
  synopsis?: InputMaybe<SortOrder>;
  titles?: InputMaybe<SortOrder>;
  validated?: InputMaybe<SortOrder>;
};

export type ProgramSellerOrderBy = {
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
};

export type ProgramV2 = {
  __typename?: 'ProgramV2';
  identifier: IdentifierV2;
  titles: Scalars['Titles']['output'];
};

export type PublicSeller = {
  __typename?: 'PublicSeller';
  identifier: Identifier;
  legalName: Scalars['String']['output'];
};

export enum Quality {
  Hd = 'HD',
  Sd = 'SD'
}

export type Query = {
  __typename?: 'Query';
  assetBuilder: AssetBuilder;
  businessProvider: BusinessProvider;
  businessProviders: PaginatedBusinessProvidersResult;
  buyer: BuyerQueries;
  buyers: BuyersQueries;
  cart: CurrentCart;
  categories: Array<Category>;
  claim: Claim;
  excludedCountriesTemplate: ExcludedCountriesTemplateObjectType;
  format: FormatQueries;
  formats: FormatsQueries;
  genres: Array<Genre>;
  license: License;
  program: Program;
  programEpisodesPrice: Scalars['Float']['output'];
  searchClaims: SearchClaimOutput;
  searchExcludedCountriesTemplates: SearchExcludedCountriesTemplateOutput;
  searchLicenses: PaginatedLicensesResult;
  searchPrograms: PaginatedProgramsResult;
  searchSourceFiles: PaginatedSourceFilesResult;
  searchTransactions: PaginatedTransactionsResult;
  seller: SellerQueries;
  sellers: SellersQueries;
  sourceFiles: Array<SourceFile>;
  transaction: Transaction;
};


export type QueryAssetBuilderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessProviderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBusinessProvidersArgs = {
  filters?: InputMaybe<BusinessProviderFiltersInput>;
  order?: InputMaybe<BusinessProviderOrderByInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QueryBuyerArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCategoriesArgs = {
  contentType: ContentType;
};


export type QueryClaimArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryExcludedCountriesTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGenresArgs = {
  contentType: ContentType;
};


export type QueryLicenseArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProgramArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProgramEpisodesPriceArgs = {
  excludedEpisodeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  programID: Scalars['UUID']['input'];
};


export type QuerySearchClaimsArgs = {
  filters?: InputMaybe<ClaimFiltersInput>;
  order?: InputMaybe<ClaimOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QuerySearchExcludedCountriesTemplatesArgs = {
  filters?: InputMaybe<ExcludedCountriesTemplateFiltersInput>;
  order?: InputMaybe<ExcludedCountriesTemplateOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
};


export type QuerySearchLicensesArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainBroadcastCountry?: InputMaybe<LicenseIsoCode>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchProgramsArgs = {
  audioLanguages?: InputMaybe<Array<LanguageIsoCode>>;
  awards?: InputMaybe<Scalars['String']['input']>;
  casting?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  directors?: InputMaybe<Scalars['String']['input']>;
  excludedGenres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  genres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  maximumEpisodesQuantity?: InputMaybe<Scalars['Int']['input']>;
  maximumFirstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumLicensesQuantity?: InputMaybe<Scalars['Int']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumEpisodesQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimumFirstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumLicensesQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProgramOrderBy>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  productionCountries?: InputMaybe<Array<CountryIsoCode>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  quality?: InputMaybe<Quality>;
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  subtitleLanguage?: InputMaybe<Array<LanguageIsoCode>>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchSourceFilesArgs = {
  contentType?: InputMaybe<SourceFileContentType>;
  detailsLanguage?: InputMaybe<LanguageIsoCode>;
  excludedStatuses?: InputMaybe<Array<SourceFileStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  maximumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  minimumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  minimumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceFileOrderBy>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<SourceFileSourceType>;
  status?: InputMaybe<SourceFileStatus>;
};


export type QuerySearchTransactionsArgs = {
  buyerContactEmail?: InputMaybe<Scalars['String']['input']>;
  buyerContactName?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['UUID']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TransactionStatus>;
};


export type QuerySellerArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySourceFilesArgs = {
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  sourceFileContentTypes?: InputMaybe<Array<SourceFileContentType>>;
};


export type QueryTransactionArgs = {
  id: Scalars['UUID']['input'];
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveFromCartInput = {
  language: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type SearchBackofficeBuyersOutput = {
  __typename?: 'SearchBackofficeBuyersOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeBuyerObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in seller legal name (ILIKE) */
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchBackofficeFormatsOutput = {
  __typename?: 'SearchBackofficeFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<FormatObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchBackofficeSellersOutput = {
  __typename?: 'SearchBackofficeSellersOutput';
  count: Scalars['Int']['output'];
  items: Array<BackofficeSellerObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchCatalogFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by genre UUIDs (OR) */
  genres?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Search in keywords (i18n ILIKE) */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Maximum first broadcast date (<=) */
  maxFirstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  /** Minimum first broadcast date (>=) */
  minFirstBroadcastDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by seller UUID */
  seller?: InputMaybe<Scalars['UUID']['input']>;
  /** Search in synopsis (i18n ILIKE) */
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchCatalogFormatsOrderByInput = {
  category?: InputMaybe<CatalogSearchDirection>;
  createdAt?: InputMaybe<CatalogSearchDirection>;
  identifier?: InputMaybe<CatalogSearchDirection>;
  productionCountry?: InputMaybe<CatalogSearchDirection>;
  timeslot?: InputMaybe<CatalogSearchDirection>;
  title?: InputMaybe<CatalogSearchDirection>;
  updatedAt?: InputMaybe<CatalogSearchDirection>;
};

export type SearchCatalogFormatsOutput = {
  __typename?: 'SearchCatalogFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<CatalogFormat>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchClaimOutput = {
  __typename?: 'SearchClaimOutput';
  claims: Array<Claim>;
  count: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchDashboardFormatsFilterInput = {
  /** Filter by category UUIDs (OR) */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Filter by SKU (exact match) */
  identifier?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by production country codes (OR) */
  productionCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by timeslots (OR) */
  timeslots?: InputMaybe<Array<FormatTimeslot>>;
  /** Search in title (i18n ILIKE) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filter by validated status */
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchDashboardFormatsOutput = {
  __typename?: 'SearchDashboardFormatsOutput';
  count: Scalars['Int']['output'];
  items: Array<DashboardFormat>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export enum SearchDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SearchExcludedCountriesTemplateOutput = {
  __typename?: 'SearchExcludedCountriesTemplateOutput';
  count: Scalars['Int']['output'];
  excludedCountriesTemplates: Array<ExcludedCountriesTemplateObjectType>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type SearchFormatsOrderByInput = {
  category?: InputMaybe<SearchDirection>;
  createdAt?: InputMaybe<SearchDirection>;
  identifier?: InputMaybe<SearchDirection>;
  productionCountry?: InputMaybe<SearchDirection>;
  sellerLegalName?: InputMaybe<SearchDirection>;
  timeslot?: InputMaybe<SearchDirection>;
  title?: InputMaybe<SearchDirection>;
  updatedAt?: InputMaybe<SearchDirection>;
};

export type SearchFormatsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export type Seller = {
  __typename?: 'Seller';
  billingEmail: Scalars['EmailAddress']['output'];
  businessProvider?: Maybe<BusinessProvider>;
  commissionRate: Scalars['Float']['output'];
  contactEmail: Scalars['EmailAddress']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  payoutTemplate: Scalars['PayoutTemplate']['output'];
  postalAddress: Scalars['String']['output'];
  tenant: Tenant;
  updatedAt: Scalars['DateTime']['output'];
  vatId: Scalars['String']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type SellerAccountMutations = {
  __typename?: 'SellerAccountMutations';
  update: AccountSellerObjectType;
};


export type SellerAccountMutationsUpdateArgs = {
  input: UpdateSellerAccountInput;
};

export type SellerBackofficeMutations = {
  __typename?: 'SellerBackofficeMutations';
  create: BackofficeSellerObjectType;
  update: BackofficeSellerObjectType;
};


export type SellerBackofficeMutationsCreateArgs = {
  input: CreateSellerInput;
};


export type SellerBackofficeMutationsUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateSellerInput;
};

export type SellerBusinessProvider = {
  __typename?: 'SellerBusinessProvider';
  contactName?: Maybe<Scalars['String']['output']>;
  identifier: Identifier;
};

export type SellerClaimFiltersInput = {
  legalName?: InputMaybe<Scalars['String']['input']>;
};

export type SellerMetrics = {
  __typename?: 'SellerMetrics';
  licensesQuantity: Scalars['Int']['output'];
  programsDuration: Scalars['Int']['output'];
  sourceFilesQuantity: Scalars['Int']['output'];
  walletBalance: Scalars['Float']['output'];
};

export type SellerMutations = {
  __typename?: 'SellerMutations';
  account: SellerAccountMutations;
  backoffice: SellerBackofficeMutations;
};

export type SellerObjectType = {
  __typename?: 'SellerObjectType';
  businessProviderId?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  legalName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SellerQueries = {
  __typename?: 'SellerQueries';
  account?: Maybe<AccountSellerObjectType>;
  backoffice?: Maybe<BackofficeSellerObjectType>;
};

export type SellerSearchFilterInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
};

export type SellerSearchOrderByInput = {
  contactEmail?: InputMaybe<SearchDirection>;
  contactName?: InputMaybe<SearchDirection>;
  legalName?: InputMaybe<SearchDirection>;
  sku?: InputMaybe<SearchDirection>;
};

export type SellerSearchPaginationInput = {
  limit: Scalars['NonNegativeInt']['input'];
  offset: Scalars['NonNegativeInt']['input'];
};

export type SellerV2 = {
  __typename?: 'SellerV2';
  identifier: IdentifierV2;
  legalName: Scalars['String']['output'];
};

export type SellersQueries = {
  __typename?: 'SellersQueries';
  backoffice: SearchBackofficeSellersOutput;
};


export type SellersQueriesBackofficeArgs = {
  filter?: InputMaybe<SellerSearchFilterInput>;
  orderBy?: InputMaybe<SellerSearchOrderByInput>;
  pagination?: InputMaybe<SellerSearchPaginationInput>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceFile = {
  __typename?: 'SourceFile';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['Details']['output']>;
  fileExtension: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  identifier: Identifier;
  originalFileName: Scalars['String']['output'];
  seller?: Maybe<Seller>;
  sourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SourceFileContentType {
  Cover = 'Cover',
  Credit = 'Credit',
  Data = 'Data',
  Master = 'Master',
  SubtitleMaster = 'SubtitleMaster',
  SubtitleTrailer = 'SubtitleTrailer',
  Trailer = 'Trailer'
}

export type SourceFileOrderBy = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  originalFileName?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  sourceType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<SourceFileTenantOrderBy>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SourceFileSourceType {
  Extract = 'Extract',
  Translate = 'Translate',
  Upload = 'Upload'
}

export enum SourceFileStatus {
  Ingested = 'INGESTED',
  IngestedError = 'INGESTED_ERROR',
  Ingesting = 'INGESTING',
  Linked = 'LINKED',
  LinkedError = 'LINKED_ERROR',
  Linking = 'LINKING',
  Parsed = 'PARSED',
  ParsedError = 'PARSED_ERROR',
  Parsing = 'PARSING',
  Uploaded = 'UPLOADED',
  UploadedError = 'UPLOADED_ERROR',
  Uploading = 'UPLOADING'
}

export type SourceFileTenantOrderBy = {
  seller?: InputMaybe<SourceFileTenantSellerOrderBy>;
};

export type SourceFileTenantSellerOrderBy = {
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
};

export type Subtitle = {
  __typename?: 'Subtitle';
  language: Scalars['String']['output'];
  sourceFile: SourceFile;
};

export type SubtitleInput = {
  language: LanguageIsoCode;
  sourceFileId: Scalars['UUID']['input'];
};

export type Tenant = {
  __typename?: 'Tenant';
  cloudFrontUrl: Scalars['String']['output'];
  kmsKeyId?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  audioOutputFormat?: Maybe<Scalars['String']['output']>;
  buyer: Buyer;
  cart: Cart;
  createdAt: Scalars['DateTime']['output'];
  identifier: Identifier;
  price: Scalars['Float']['output'];
  status: TransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  videoOutputBitrate: Scalars['String']['output'];
  videoOutputFormat: Scalars['String']['output'];
};

export type TransactionBuyerOrderBy = {
  contactEmail?: InputMaybe<SortOrder>;
  contactName?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  publicName?: InputMaybe<SortOrder>;
};

export type TransactionOrderBy = {
  buyer?: InputMaybe<TransactionBuyerOrderBy>;
  buyerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum TransactionStatus {
  Error = 'ERROR',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export enum TransactionStatusInput {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type TransactionV2 = {
  __typename?: 'TransactionV2';
  buyer: BuyerV2;
  identifier: IdentifierV2;
};

export type UpdateBuyerAccountInput = {
  audioOutputFormat?: InputMaybe<NestAudioOutputFormat>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  broadcastCountries?: InputMaybe<BroadcastCountriesInput>;
  broadcastLanguage?: InputMaybe<LanguageIsoCode>;
  cognitoPassword?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  videoOutputBitrate?: InputMaybe<NestVideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<NestVideoOutputFormat>;
};

export type UpdateBuyerInput = {
  audioOutputFormat?: InputMaybe<NestAudioOutputFormat>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  broadcastCountries?: InputMaybe<BroadcastCountriesInput>;
  broadcastLanguage?: InputMaybe<LanguageIsoCode>;
  broadcastType?: InputMaybe<NestBroadcastType>;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  hourCost?: InputMaybe<Scalars['Float']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  licensesDuration?: InputMaybe<Scalars['Int']['input']>;
  payoutTemplate?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  replayRights?: InputMaybe<Scalars['Boolean']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
  videoOutputBitrate?: InputMaybe<NestVideoOutputBitrate>;
  videoOutputFormat?: InputMaybe<NestVideoOutputFormat>;
};

export type UpdateCartInput = {
  currentLanguage: LanguageIsoCode;
  newLanguage: LanguageIsoCode;
  programId: Scalars['UUID']['input'];
};

export type UpdateExcludedCountriesTemplateInput = {
  excludedCountries?: InputMaybe<Array<ExcludedCountryInputType>>;
  templateId: Scalars['UUID']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormatInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  coverImageFileId?: InputMaybe<Scalars['UUID']['input']>;
  editorialization?: InputMaybe<EditorializationInput>;
  excludedCountries?: InputMaybe<Array<ExcludedCountryInput>>;
  firstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  frapaId?: InputMaybe<Scalars['String']['input']>;
  genreIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  masterFileId?: InputMaybe<Scalars['UUID']['input']>;
  otherProductionCountries?: InputMaybe<Array<OtherProductionCountryInput>>;
  productionCountry?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rightExclusivity?: InputMaybe<Scalars['Boolean']['input']>;
  timeslot?: InputMaybe<FormatTimeslot>;
  trailerFileId?: InputMaybe<Scalars['UUID']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSellerAccountInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  cognitoPassword?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSellerInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessProviderId?: InputMaybe<Scalars['UUID']['input']>;
  commissionRate?: InputMaybe<Scalars['Float']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  payoutTemplate?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<Scalars['String']['input']>;
  vatId?: InputMaybe<Scalars['String']['input']>;
};

/** Uploaded part */
export type UploadedPart = {
  __typename?: 'UploadedPart';
  etag: Scalars['String']['output'];
  partNumber: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
};

export type UploadedPartInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export enum VideoOutputBitrateOutput {
  B_2_5 = 'B_2_5',
  B_5 = 'B_5',
  B_25 = 'B_25',
  B_30 = 'B_30',
  B_50 = 'B_50'
}

export enum VideoOutputFormatOutput {
  Mov = 'MOV',
  Mp4 = 'MP4',
  Mxf = 'MXF'
}

export type BusinessProvidersQueryVariables = Exact<{
  filters?: InputMaybe<BusinessProviderFiltersInput>;
  order?: InputMaybe<BusinessProviderOrderByInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type BusinessProvidersQuery = { __typename?: 'Query', businessProviders: { __typename?: 'PaginatedBusinessProvidersResult', count: number, limit: number, offset: number, items: Array<{ __typename?: 'BusinessProvider', legalName: string, contactEmail: string, contactName: string, licensesQuantity: number, programsDuration: number, createdAt: string, postalAddress: string, vatId: string, billingEmail: string, updatedAt: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, bankAccountDetails: { __typename?: 'BankAccountDetails', iban: string, bic: string } }> } };

export type UpdateBusinessProviderMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
}>;


export type UpdateBusinessProviderMutation = { __typename?: 'Mutation', updateBusinessProvider: { __typename: 'BusinessProvider' } };

export type CreateBusinessProviderMutationVariables = Exact<{
  bic: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postalAddress: Scalars['String']['input'];
  vatId: Scalars['String']['input'];
}>;


export type CreateBusinessProviderMutation = { __typename?: 'Mutation', createBusinessProvider: { __typename: 'BusinessProvider' } };

export type DeleteBusinessProviderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBusinessProviderMutation = { __typename?: 'Mutation', deleteBusinessProvider: { __typename: 'DeleteBusinessProviderResult' } };

export type SearchBuyersQueryVariables = Exact<{
  filter?: InputMaybe<BuyerSearchFilterInput>;
  orderBy?: InputMaybe<BuyerSearchOrderByInput>;
  pagination?: InputMaybe<BuyerSearchPaginationInput>;
}>;


export type SearchBuyersQuery = { __typename?: 'Query', buyers: { __typename?: 'BuyersQueries', backoffice: { __typename?: 'SearchBackofficeBuyersOutput', count: number, items: Array<{ __typename?: 'BackofficeBuyerObjectType', billingEmail: string, broadcastLanguage: LanguageIsoCode, broadcastType: NestBroadcastType, contactEmail: string, contactName: string, hourCost: number, legalName: string, licensesDuration: number, payoutTemplate: any, postalAddress: string, publicName: string, replayRights: boolean, vatId: string, videoOutputBitrate: NestVideoOutputBitrate, videoOutputFormat: NestVideoOutputFormat, broadcastCountries: { __typename?: 'BroadcastCountriesType', countries: Array<CountryIsoCode>, main: CountryIsoCode }, identifier: { __typename?: 'Identifier', id: string, sku: number }, businessProvider?: { __typename?: 'BuyerBusinessProvider', contactName?: string | null, identifier: { __typename?: 'Identifier', sku: number, id: string } } | null }> } } };

export type BuyerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', backoffice?: { __typename?: 'BackofficeBuyerObjectType', contactEmail: string, contactName: string, legalName: string, postalAddress: string, publicName: string, replayRights: boolean, videoOutputBitrate: NestVideoOutputBitrate, videoOutputFormat: NestVideoOutputFormat, billingEmail: string, broadcastLanguage: LanguageIsoCode, vatId: string, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null } };

export type BuyerSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerSummaryQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', backoffice?: { __typename?: 'BackofficeBuyerObjectType', legalName: string, publicName: string, contactName: string, broadcastLanguage: LanguageIsoCode, videoOutputBitrate: NestVideoOutputBitrate, videoOutputFormat: NestVideoOutputFormat, payinIban?: string | null, identifier: { __typename?: 'Identifier', id: string }, broadcastCountries: { __typename?: 'BroadcastCountriesType', countries: Array<CountryIsoCode>, main: CountryIsoCode } } | null } };

export type UpdateBuyerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateBuyerInput;
}>;


export type UpdateBuyerMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', backoffice: { __typename?: 'BuyerBackofficeMutations', update: { __typename?: 'BackofficeBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CreateBuyerMutationVariables = Exact<{
  input: CreateBuyerInput;
}>;


export type CreateBuyerMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', backoffice: { __typename?: 'BuyerBackofficeMutations', create: { __typename?: 'BackofficeBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type BuyerAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BuyerAccountQuery = { __typename?: 'Query', buyer: { __typename?: 'BuyerQueries', account?: { __typename?: 'AccountBuyerObjectType', contactName: string, contactEmail: string, publicName: string, postalAddress: string, billingEmail: string, legalName: string, vatId: string, videoOutputFormat: NestVideoOutputFormat, videoOutputBitrate: NestVideoOutputBitrate, broadcastLanguage: LanguageIsoCode, identifier: { __typename?: 'Identifier', id: string, sku: number }, broadcastCountries: { __typename?: 'BroadcastCountriesType', countries: Array<CountryIsoCode>, main: CountryIsoCode } } | null } };

export type UpdateBuyerAccountMutationVariables = Exact<{
  input: UpdateBuyerAccountInput;
}>;


export type UpdateBuyerAccountMutation = { __typename?: 'Mutation', buyer: { __typename?: 'BuyerMutations', account: { __typename?: 'BuyerAccountMutations', update: { __typename?: 'AccountBuyerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart: { __typename?: 'CurrentCart', total: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: string, program: { __typename?: 'CurrentCartProgramDetail', titles: any, coverUrl?: string | null, creditRollUrl?: string | null, duration: number, audioLanguages: any, price: number, firstBroadcastDate?: string | null, episodeNumber?: number | null, episodesQuantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, masterSubtitles: Array<{ __typename?: 'CurrentCartProgramSubtitle', language: string }>, parent?: { __typename?: 'CurrentCartProgramParent', titles: any, identifier: { __typename?: 'CurrentCartIdentifier', id: string } } | null, seller: { __typename?: 'CurrentCartProgramSeller', legalName: string } } }> } };

export type AddToCartMutationVariables = Exact<{
  input: AddToCartInput;
}>;


export type AddToCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', addToCart: { __typename?: 'CurrentCart', total: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: string, program: { __typename?: 'CurrentCartProgramDetail', titles: any, coverUrl?: string | null, creditRollUrl?: string | null, duration: number, audioLanguages: any, price: number, firstBroadcastDate?: string | null, episodeNumber?: number | null, episodesQuantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, masterSubtitles: Array<{ __typename?: 'CurrentCartProgramSubtitle', language: string }>, parent?: { __typename?: 'CurrentCartProgramParent', titles: any, identifier: { __typename?: 'CurrentCartIdentifier', id: string } } | null, seller: { __typename?: 'CurrentCartProgramSeller', legalName: string } } }> } } } };

export type RemoveFromCartMutationVariables = Exact<{
  input: RemoveFromCartInput;
}>;


export type RemoveFromCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', removeFromCart: { __typename?: 'CurrentCart', total: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: string, program: { __typename?: 'CurrentCartProgramDetail', titles: any, coverUrl?: string | null, creditRollUrl?: string | null, duration: number, audioLanguages: any, price: number, firstBroadcastDate?: string | null, episodeNumber?: number | null, episodesQuantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, masterSubtitles: Array<{ __typename?: 'CurrentCartProgramSubtitle', language: string }>, parent?: { __typename?: 'CurrentCartProgramParent', titles: any, identifier: { __typename?: 'CurrentCartIdentifier', id: string } } | null, seller: { __typename?: 'CurrentCartProgramSeller', legalName: string } } }> } } } };

export type UpdateCartMutationVariables = Exact<{
  input: UpdateCartInput;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', cart: { __typename?: 'CartMutations', billing: { __typename?: 'CartBillingMutations', updateCart: { __typename?: 'CurrentCart', total: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, programs: Array<{ __typename?: 'CurrentCartProgram', language: string, program: { __typename?: 'CurrentCartProgramDetail', titles: any, coverUrl?: string | null, creditRollUrl?: string | null, duration: number, audioLanguages: any, price: number, firstBroadcastDate?: string | null, episodeNumber?: number | null, episodesQuantity: number, identifier: { __typename?: 'CurrentCartIdentifier', id: string }, masterSubtitles: Array<{ __typename?: 'CurrentCartProgramSubtitle', language: string }>, parent?: { __typename?: 'CurrentCartProgramParent', titles: any, identifier: { __typename?: 'CurrentCartIdentifier', id: string } } | null, seller: { __typename?: 'CurrentCartProgramSeller', legalName: string } } }> } } } };

export type GetCategoriesQueryVariables = Exact<{
  contentType: ContentType;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, title: string, catchPhrase: string, image: string }> };

export type CreateClaimMutationVariables = Exact<{
  input: CreateClaimInput;
}>;


export type CreateClaimMutation = { __typename?: 'Mutation', createClaim: { __typename?: 'Claim', identifier: { __typename?: 'IdentifierV2', id: string, sku: number } } };

export type SearchClaimsQueryVariables = Exact<{
  filters?: InputMaybe<ClaimFiltersInput>;
  order?: InputMaybe<ClaimOrderInput>;
  pagination?: InputMaybe<SearchPaginationInput>;
}>;


export type SearchClaimsQuery = { __typename?: 'Query', searchClaims: { __typename?: 'SearchClaimOutput', count: number, limit: number, offset: number, claims: Array<{ __typename?: 'Claim', message: string, status: ClaimStatusOutput, createdAt: string, license?: { __typename?: 'LicenseV2', seller: { __typename?: 'SellerV2', legalName: string, identifier: { __typename?: 'IdentifierV2', id: string, sku: number } }, identifier: { __typename?: 'IdentifierV2', id: string, sku: number }, buyer: { __typename?: 'BuyerV2', contactEmail: string, contactName: string, legalName: string, identifier: { __typename?: 'IdentifierV2', id: string, sku: number } }, program: { __typename?: 'ProgramV2', titles: import("./scalars").TitleMap, identifier: { __typename?: 'IdentifierV2', id: string, sku: number } } } | null, identifier: { __typename?: 'IdentifierV2', id: string, sku: number } }> } };

export type UpdateClaimStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: ClaimStatusInput;
}>;


export type UpdateClaimStatusMutation = { __typename?: 'Mutation', updateClaimStatus: { __typename?: 'Claim', identifier: { __typename?: 'IdentifierV2', id: string, sku: number } } };

export type CreateExcludedCountriesTemplateMutationVariables = Exact<{
  input: CreateExcludedCountriesTemplateInput;
}>;


export type CreateExcludedCountriesTemplateMutation = { __typename?: 'Mutation', createExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, createdAt: string, updatedAt?: string | null, identifier: { __typename?: 'IdentifierV2', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> } };

export type GetExclusionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExclusionTemplatesQuery = { __typename?: 'Query', searchExcludedCountriesTemplates: { __typename?: 'SearchExcludedCountriesTemplateOutput', count: number, excludedCountriesTemplates: Array<{ __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, createdAt: string, updatedAt?: string | null, identifier: { __typename?: 'IdentifierV2', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> }> } };

export type GetExcludedCountriesTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetExcludedCountriesTemplateQuery = { __typename?: 'Query', excludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, createdAt: string, updatedAt?: string | null, identifier: { __typename?: 'IdentifierV2', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> } };

export type UpdateExcludedCountriesTemplateMutationVariables = Exact<{
  input: UpdateExcludedCountriesTemplateInput;
}>;


export type UpdateExcludedCountriesTemplateMutation = { __typename?: 'Mutation', updateExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', templateName: string, updatedAt?: string | null, identifier: { __typename?: 'IdentifierV2', id: string }, excludedCountries: Array<{ __typename?: 'ExcludedCountryObjectType', countryISOCode: CountryIsoCode, exclusionType: CountryExclusionTypeObjectType }> } };

export type DeleteExcludedCountriesTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DeleteExcludedCountriesTemplateMutation = { __typename?: 'Mutation', deleteExcludedCountriesTemplate: { __typename?: 'ExcludedCountriesTemplateObjectType', identifier: { __typename?: 'IdentifierV2', id: string } } };

export type SearchFormatsQueryVariables = Exact<{
  filter?: InputMaybe<SearchCatalogFormatsFilterInput>;
  orderBy?: InputMaybe<SearchCatalogFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', catalog: { __typename?: 'SearchCatalogFormatsOutput', count: number, items: Array<{ __typename?: 'CatalogFormat', coverUrl?: string | null, category?: { __typename?: 'Category', catchPhrase: string, id: string, image: string, title: string } | null, editorialization?: { __typename?: 'EditorializationObjectType', keywords: Array<string>, synopsis: string, title: string } | null, genres: Array<{ __typename?: 'Genre', title: string, id: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null }> } } };

export type SearchFormatsDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SearchDashboardFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsDashboardQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', dashboard: { __typename?: 'SearchDashboardFormatsOutput', count: number, items: Array<{ __typename?: 'DashboardFormat', coverUrl?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', catchPhrase: string, id: string, image: string, title: string }, editorialization: { __typename?: 'EditorializationObjectType', keywords: Array<string>, synopsis: string, title: string }, genres: Array<{ __typename?: 'Genre', title: string, id: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean } | null, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null }> } } };

export type SearchFormatsBoQueryVariables = Exact<{
  filter?: InputMaybe<SearchBackofficeFormatsFilterInput>;
  orderBy?: InputMaybe<SearchFormatsOrderByInput>;
  pagination?: InputMaybe<SearchFormatsPaginationInput>;
}>;


export type SearchFormatsBoQuery = { __typename?: 'Query', formats: { __typename?: 'FormatsQueries', backoffice: { __typename?: 'SearchBackofficeFormatsOutput', count: number, items: Array<{ __typename?: 'FormatObjectType', coverUrl?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', title: string }, editorialization: { __typename?: 'EditorializationObjectType', title: string, durationDescription?: string | null }, identifier: { __typename?: 'Identifier', id: string, sku: number }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean, rightExclusivity: boolean } | null, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null }> } } };

export type FormatQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', catalog: { __typename?: 'CatalogFormat', coverUrl?: string | null, frapaId?: string | null, masterPreviewUrl?: string | null, masterSubtitleUrl?: string | null, trailerPreviewUrl?: string | null, trailerSubtitleUrl?: string | null, rightExclusivity: boolean, timeslot: FormatTimeslot, category?: { __typename?: 'Category', id: string, title: string } | null, editorialization?: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string } | null, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, otherProductionCountries: Array<{ __typename?: 'OtherProductionCountryObjectType', countryIsoCode: string, year: string }>, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null, seller?: { __typename?: 'PublicSeller', legalName: string } | null } } };

export type FormatBoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatBoQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', backoffice?: { __typename?: 'FormatObjectType', coverUrl?: string | null, frapaId?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', id: string, title: string }, editorialization: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string }, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean, rightExclusivity: boolean } | null, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string } | null } | null } };

export type FormatDashboardQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormatDashboardQuery = { __typename?: 'Query', format: { __typename?: 'FormatQueries', dashboard?: { __typename?: 'DashboardFormat', coverUrl?: string | null, frapaId?: string | null, masterPreviewUrl?: string | null, masterSubtitleUrl?: string | null, trailerPreviewUrl?: string | null, trailerSubtitleUrl?: string | null, timeslot: FormatTimeslot, category: { __typename?: 'Category', id: string, title: string }, editorialization: { __typename?: 'EditorializationObjectType', durationDescription?: string | null, keywords: Array<string>, synopsis: string, title: string }, genres: Array<{ __typename?: 'Genre', id: string, title: string }>, identifier: { __typename?: 'Identifier', id: string }, lifecycle?: { __typename?: 'LifecycleObjectType', published: boolean, validated: boolean, rightExclusivity: boolean } | null, otherProductionCountries: Array<{ __typename?: 'OtherProductionCountryObjectType', countryIsoCode: string, year: string }>, production?: { __typename?: 'ProductionObjectType', firstBroadcastDate?: string | null, productionCountry?: string | null } | null, seller?: { __typename?: 'SellerObjectType', legalName: string } | null } | null } };

export type UpdateFormatMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateFormatInput;
}>;


export type UpdateFormatMutation = { __typename?: 'Mutation', format: { __typename?: 'FormatMutations', dashboard: { __typename?: 'FormatDashboardMutations', update: { __typename?: 'FormatObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type DeleteFormatMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteFormatMutation = { __typename?: 'Mutation', format: { __typename?: 'FormatMutations', backoffice: { __typename?: 'FormatBackofficeMutations', delete: { __typename?: 'DeleteFormatOutput', id: string, success: boolean } } } };

export type GetGenresQueryVariables = Exact<{
  contentType: ContentType;
}>;


export type GetGenresQuery = { __typename?: 'Query', genres: Array<{ __typename?: 'Genre', id: string, title: string }> };

export type SearchLicensesQueryVariables = Exact<{
  programTitle?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  mainBroadcastCountry?: InputMaybe<LicenseIsoCode>;
  maximumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumEndingDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<LicenseOrderBy>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  asAdmin?: Scalars['Boolean']['input'];
  asSeller?: Scalars['Boolean']['input'];
  includeContent?: Scalars['Boolean']['input'];
}>;


export type SearchLicensesQuery = { __typename?: 'Query', searchLicenses: { __typename?: 'PaginatedLicensesResult', count: number, limit: number, offset: number, licenses: Array<{ __typename?: 'License', clearanceDate: string, createdAt: string, endingDate?: string | null, price: number, updatedAt?: string | null, buyer: { __typename?: 'Buyer', legalName: string, publicName: string, broadcastLanguage?: string, broadcastType?: string, postalAddress?: string, vatId?: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, broadcastCountries: { __typename?: 'BroadcastCountries', main: CountryIsoCode, countries: Array<CountryIsoCode> }, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } }, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string, vatId: string, postalAddress?: string, identifier?: { __typename?: 'Identifier', id: string, sku: number } }, program: { __typename?: 'Program', titles: import("./scalars").TitleMap, coverUrl?: string | null, isSegmentable: boolean, creditRollUrl?: string | null, firstBroadcastDate?: string | null, episodeNumber?: number | null, duration?: number | null, episodesQuantity?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, creditRollFile?: { __typename?: 'SourceFile', id: string, fileExtension: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, parent?: { __typename?: 'Program', titles: import("./scalars").TitleMap, episodesQuantity?: number | null, firstBroadcastDate?: string | null, identifier: { __typename?: 'Identifier', id: string } } | null }, transaction?: { __typename?: 'Transaction', createdAt: string }, assetBuilder?: { __typename?: 'AssetBuilder', status?: string, audioLanguage: string, audioOutputFormat?: string | null, videoOutputBitrate?: string, videoOutputFormat?: string, subtitleLanguage: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, contents?: Array<{ __typename?: 'Contents', subtitleUrl: string, videoUrl: string, duration: number, episodeNumber?: number | null, titles: import("./scalars").TitleMap }> } | null }> } };

export type UpdateProgramLinkingMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  coverImageFileId?: InputMaybe<Scalars['UUID']['input']>;
  creditRollFileId?: InputMaybe<Scalars['UUID']['input']>;
  masterFileId?: InputMaybe<Scalars['UUID']['input']>;
  masterSubtitles?: InputMaybe<Array<SubtitleInput> | SubtitleInput>;
  trailerFileId?: InputMaybe<Scalars['UUID']['input']>;
  trailerSubtitles?: InputMaybe<Array<SubtitleInput> | SubtitleInput>;
}>;


export type UpdateProgramLinkingMutation = { __typename?: 'Mutation', updateProgram: { __typename?: 'Program', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type SearchProgramsForLinkingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  orderBy?: InputMaybe<ProgramOrderBy>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageIsoCode>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchProgramsForLinkingQuery = { __typename?: 'Query', searchPrograms: { __typename?: 'PaginatedProgramsResult', count: number, Programs: Array<{ __typename?: 'Program', episodesQuantity?: number | null, emptyEpisodes?: number | null, titles: import("./scalars").TitleMap, episodeNumber?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, parent?: { __typename?: 'Program', identifier: { __typename?: 'Identifier', id: string } } | null, seller: { __typename?: 'Seller', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, masterFile?: { __typename?: 'SourceFile', id: string, originalFileName: string } | null, masterSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, originalFileName: string, sourceType: string, details?: import("./scalars").DetailsObject | null } }> | null, trailerFile?: { __typename?: 'SourceFile', id: string, originalFileName: string } | null, trailerSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, originalFileName: string, sourceType: string, details?: import("./scalars").DetailsObject | null } }> | null, coverImageFile?: { __typename?: 'SourceFile', id: string, originalFileName: string } | null, creditRollFile?: { __typename?: 'SourceFile', id: string, originalFileName: string } | null }> } };

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  includeSensitiveData?: Scalars['Boolean']['input'];
  includeMasterFiles?: Scalars['Boolean']['input'];
}>;


export type GetProgramByIdQuery = { __typename?: 'Query', program: { __typename?: 'Program', audioLanguages: { main: LanguageIsoCode; languages: LanguageIsoCode[] }, awards?: string | null, casting?: string | null, countriesRight?: Array<CountryIsoCode> | null, directors?: string | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, published?: boolean, validated?: boolean, firstBroadcastDate?: string | null, imdb?: string | null, keywords?: import("./scalars").Keywords | null, licensesQuantity?: number | null, price?: number | null, productionCountryIsoCode?: string | null, quality?: string | null, synopsis: import("./scalars").Synopsis, titles: import("./scalars").TitleMap, category: { __typename?: 'CategoryProgram', catchPhrase: string, id: string, image: string, title: string }, excludedCountries?: Array<{ __typename?: 'ExcludedCountry', countryISOCode: CountryIsoCode, exclusionType: ExclusionType }> | null, genres: Array<{ __typename?: 'GenreProgram', title: string, id: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, coverImageFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, trailerFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, trailerSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, originalFileName: string, sourceType: string, details?: import("./scalars").DetailsObject | null, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, masterFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, masterSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, originalFileName: string, sourceType: string, details?: import("./scalars").DetailsObject | null, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, creditRollFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null } };

export type SearchProgramsQueryVariables = Exact<{
  audioLanguages?: InputMaybe<Array<LanguageIsoCode> | LanguageIsoCode>;
  awards?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  directors?: InputMaybe<Scalars['String']['input']>;
  genres?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageIsoCode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  maximumEpisodesQuantity?: InputMaybe<Scalars['Int']['input']>;
  maximumFirstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  maximumLicensesQuantity?: InputMaybe<Scalars['Int']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumEpisodesQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimumFirstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumLicensesQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProgramOrderBy>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  productionCountries?: InputMaybe<Array<CountryIsoCode> | CountryIsoCode>;
  quality?: InputMaybe<Quality>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
  excludedGenres?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  subtitleLanguage?: InputMaybe<Array<LanguageIsoCode> | LanguageIsoCode>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
  includeSensitiveData?: Scalars['Boolean']['input'];
  includeMasterFiles?: Scalars['Boolean']['input'];
  includeSellerData?: Scalars['Boolean']['input'];
}>;


export type SearchProgramsQuery = { __typename?: 'Query', searchPrograms: { __typename?: 'PaginatedProgramsResult', count: number, Programs: Array<{ __typename?: 'Program', audioLanguages: { main: LanguageIsoCode; languages: LanguageIsoCode[] }, awards?: string | null, casting?: string | null, countriesRight?: Array<CountryIsoCode> | null, directors?: string | null, coverUrl?: string | null, creditRollUrl?: string | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, firstBroadcastDate?: string | null, imdb?: string | null, keywords?: import("./scalars").Keywords | null, licensesQuantity?: number | null, price?: number | null, productionCountryIsoCode?: string | null, quality?: string | null, synopsis: import("./scalars").Synopsis, titles: import("./scalars").TitleMap, validated?: boolean, published?: boolean, category: { __typename?: 'CategoryProgram', catchPhrase: string, id: string, image: string, title: string }, genres: Array<{ __typename?: 'GenreProgram', title: string, id: string }>, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller?: { __typename?: 'Seller', legalName: string, identifier: { __typename?: 'Identifier', id: string, sku: number } }, parent?: { __typename?: 'Program', coverUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null, trailerFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, trailerSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, masterFile?: { __typename?: 'SourceFile', id: string, details?: import("./scalars").DetailsObject | null, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, masterSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, coverImageFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null }> } };

export type ProgramQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  includeSensitiveData?: Scalars['Boolean']['input'];
  includeMasterFiles?: Scalars['Boolean']['input'];
}>;


export type ProgramQuery = { __typename?: 'Query', program: { __typename?: 'Program', audioLanguages: { main: LanguageIsoCode; languages: LanguageIsoCode[] }, awards?: string | null, casting?: string | null, isExclusive: boolean, isSegmentable: boolean, countriesRight?: Array<CountryIsoCode> | null, creditRollUrl?: string | null, coverUrl?: string | null, directors?: string | null, duration?: number | null, episodeNumber?: number | null, episodesQuantity?: number | null, published?: boolean, validated?: boolean, firstBroadcastDate?: string | null, imdb?: string | null, keywords?: import("./scalars").Keywords | null, licensesQuantity?: number | null, price?: number | null, productionCountryIsoCode?: string | null, quality?: string | null, synopsis: import("./scalars").Synopsis, titles: import("./scalars").TitleMap, category: { __typename?: 'CategoryProgram', catchPhrase: string, id: string, image: string, title: string }, publicSeller: { __typename?: 'PublicSeller', legalName: string }, excludedCountries?: Array<{ __typename?: 'ExcludedCountry', countryISOCode: CountryIsoCode, exclusionType: ExclusionType }> | null, genres: Array<{ __typename?: 'GenreProgram', title: string, id: string }>, parent?: { __typename?: 'Program', creditRollUrl?: string | null, coverUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, coverImageFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, trailerFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, trailerSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, masterFile?: { __typename?: 'SourceFile', id: string, details?: import("./scalars").DetailsObject | null, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null, masterSubtitles?: Array<{ __typename?: 'Subtitle', language: string, sourceFile: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } }> | null, creditRollFile?: { __typename?: 'SourceFile', id: string, fileExtension: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null } };

export type UpdateProgramMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  awards?: InputMaybe<Scalars['String']['input']>;
  casting?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  directors?: InputMaybe<Scalars['String']['input']>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  excludedCountries?: InputMaybe<Array<ExcludedCountryInput> | ExcludedCountryInput>;
  firstBroadcastDate?: InputMaybe<Scalars['DateTime']['input']>;
  genreIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  isSegmentable?: InputMaybe<Scalars['Boolean']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  imdb?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Scalars['Keywords']['input']>;
  productionCountry?: InputMaybe<CountryIsoCode>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  synopsis?: InputMaybe<Scalars['Synopsis']['input']>;
  titles?: InputMaybe<Scalars['Titles']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProgramMutation = { __typename?: 'Mutation', updateProgram: { __typename?: 'Program', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type DeleteProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', deleteProgram: { __typename?: 'Program', identifier: { __typename?: 'Identifier', id: string } } };

export type GetEpisodesPriceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  excludedEpisodeIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetEpisodesPriceQuery = { __typename?: 'Query', programEpisodesPrice: number };

export type SearchSellersQueryVariables = Exact<{
  filter?: InputMaybe<SellerSearchFilterInput>;
  orderBy?: InputMaybe<SellerSearchOrderByInput>;
  pagination?: InputMaybe<SellerSearchPaginationInput>;
}>;


export type SearchSellersQuery = { __typename?: 'Query', sellers: { __typename?: 'SellersQueries', backoffice: { __typename?: 'SearchBackofficeSellersOutput', count: number, items: Array<{ __typename?: 'BackofficeSellerObjectType', legalName: string, contactEmail: string, contactName: string, postalAddress: string, billingEmail: string, vatId: string, commissionRate: number, payoutTemplate: any, identifier: { __typename?: 'Identifier', sku: number, id: string }, businessProvider?: { __typename?: 'SellerBusinessProvider', contactName?: string | null, identifier: { __typename?: 'Identifier', sku: number, id: string } } | null }> } } };

export type SellerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', backoffice?: { __typename?: 'BackofficeSellerObjectType', legalName: string, contactEmail: string, contactName: string, postalAddress: string, billingEmail: string, vatId: string, walletBalance: number, identifier: { __typename?: 'Identifier', id: string, sku: number } } | null } };

export type SellerSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerSummaryQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', backoffice?: { __typename?: 'BackofficeSellerObjectType', legalName: string, contactName: string, identifier: { __typename?: 'Identifier', id: string } } | null } };

export type UpdateSellerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateSellerInput;
}>;


export type UpdateSellerMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', backoffice: { __typename?: 'SellerBackofficeMutations', update: { __typename?: 'BackofficeSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type CreateSellerMutationVariables = Exact<{
  input: CreateSellerInput;
}>;


export type CreateSellerMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', backoffice: { __typename?: 'SellerBackofficeMutations', create: { __typename?: 'BackofficeSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type WalletWithdrawMutationVariables = Exact<{
  sellerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type WalletWithdrawMutation = { __typename?: 'Mutation', walletWithdraw: boolean };

export type SellerAccountQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SellerAccountQuery = { __typename?: 'Query', seller: { __typename?: 'SellerQueries', account?: { __typename?: 'AccountSellerObjectType', legalName: string, postalAddress: string, billingEmail: string, vatId: string, contactEmail: string, contactName: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, metrics: { __typename?: 'SellerMetrics', licensesQuantity: number, programsDuration: number, sourceFilesQuantity: number, walletBalance: number } } | null } };

export type UpdateSellerAccountMutationVariables = Exact<{
  input: UpdateSellerAccountInput;
}>;


export type UpdateSellerAccountMutation = { __typename?: 'Mutation', seller: { __typename?: 'SellerMutations', account: { __typename?: 'SellerAccountMutations', update: { __typename?: 'AccountSellerObjectType', identifier: { __typename?: 'Identifier', id: string, sku: number } } } } };

export type SearchSourceFilesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceFileOrderBy>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SourceFileStatus>;
  contentType?: InputMaybe<SourceFileContentType>;
  sourceType?: InputMaybe<SourceFileSourceType>;
  minimumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  maximumFileSize?: InputMaybe<Scalars['BigInt']['input']>;
  minimumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maximumLastModified?: InputMaybe<Scalars['DateTime']['input']>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  sellerLegalName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchSourceFilesListQuery = { __typename?: 'Query', searchSourceFiles: { __typename?: 'PaginatedSourceFilesResult', count: number, sourceFiles: Array<{ __typename?: 'SourceFile', id: string, originalFileName: string, sourceType: string, status: string, contentType: string, fileSize: string, updatedAt: string, identifier: { __typename?: 'Identifier', sku: number, id: string }, seller?: { __typename?: 'Seller', legalName: string, identifier: { __typename?: 'Identifier', id: string } } | null }> } };

export type SearchSourceFilesBySellerIdQueryVariables = Exact<{
  sellerId: Scalars['UUID']['input'];
  contentType: SourceFileContentType;
  status?: InputMaybe<SourceFileStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceFileOrderBy>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  detailsLanguage?: InputMaybe<LanguageIsoCode>;
  sourceType?: InputMaybe<SourceFileSourceType>;
}>;


export type SearchSourceFilesBySellerIdQuery = { __typename?: 'Query', searchSourceFiles: { __typename?: 'PaginatedSourceFilesResult', sourceFiles: Array<{ __typename?: 'SourceFile', id: string, originalFileName: string, contentType: string, createdAt: string, details?: import("./scalars").DetailsObject | null, sourceType: string, status: string }> } };

export type DeleteSourceFileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSourceFileMutation = { __typename?: 'Mutation', deleteSourceFile: boolean };

export type SearchTransactionsQueryVariables = Exact<{
  buyerContactEmail?: InputMaybe<Scalars['String']['input']>;
  buyerContactName?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['UUID']['input']>;
  buyerLegalName?: InputMaybe<Scalars['String']['input']>;
  buyerPublicName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maximumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minimumPrice?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  sku?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TransactionStatus>;
}>;


export type SearchTransactionsQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'PaginatedTransactionsResult', count: number, transactions: Array<{ __typename?: 'Transaction', price: number, status: TransactionStatus, updatedAt: string, createdAt: string, identifier: { __typename?: 'Identifier', id: string, sku: number }, cart: { __typename?: 'Cart', identifier: { __typename?: 'Identifier', id: string } }, buyer: { __typename?: 'Buyer', legalName: string, publicName: string, contactName: string, contactEmail: string, identifier: { __typename?: 'Identifier', id: string, sku: number } } }> } };

export type TransactionCartContentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TransactionCartContentQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', cart: { __typename?: 'Cart', programs: Array<{ __typename?: 'CartProgram', program: { __typename?: 'Program', titles: import("./scalars").TitleMap, duration?: number | null, episodesQuantity?: number | null, episodeNumber?: number | null, coverUrl?: string | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, seller: { __typename?: 'Seller', legalName: string }, parent?: { __typename?: 'Program', titles: import("./scalars").TitleMap, episodesQuantity?: number | null, identifier: { __typename?: 'Identifier', id: string, sku: number }, coverImageFile?: { __typename?: 'SourceFile', id: string, tenantId: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null } | null, coverImageFile?: { __typename?: 'SourceFile', id: string, tenant?: { __typename?: 'Tenant', cloudFrontUrl: string } | null } | null } }> } } };

export type CreateTransactionMutationVariables = Exact<{
  cartId: Scalars['UUID']['input'];
  videoOutputBitrate: BuyerVideoOutputBitrate;
  videoOutputFormat: BuyerVideoOutputFormat;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'Transaction', identifier: { __typename?: 'Identifier', id: string, sku: number } } };

export type UpdateTransactionStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: TransactionStatusInput;
}>;


export type UpdateTransactionStatusMutation = { __typename?: 'Mutation', updateTransactionStatus: { __typename?: 'TransactionV2', identifier: { __typename?: 'IdentifierV2', id: string, sku: number } } };

export type TransactionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TransactionQuery = { __typename?: 'Query', transaction: { __typename?: 'Transaction', price: number, status: TransactionStatus, updatedAt: string, createdAt: string, identifier: { __typename?: 'Identifier', id: string, sku: number } } };
